import {ParamsModel} from 'src/app/modules/common/Model'
import {actionTypes} from './constants'

export const actions = {
  // GET
  getTisaForexRateCategory: (params: ParamsModel = {page: 1, limit: 10}) => ({
    type: actionTypes.GET_TISA_FOREX_RATE_CATEGORY_START,
    payload: {params},
  }),
  getTisaForexRateCategorySuccess: (data: any) => ({
    type: actionTypes.GET_TISA_FOREX_RATE_CATEGORY_SUCCESS,
    payload: data,
  }),
  getTisaForexRateCategoryFinish: () => ({
    type: actionTypes.GET_TISA_FOREX_RATE_CATEGORY_FINISH,
  }),

  // GET ALL
  getAllTisaForexRateCategory: (params: ParamsModel = {page: 1, limit: 10}) => ({
    type: actionTypes.GET_ALL_TISA_FOREX_RATE_CATEGORY_START,
    payload: {params},
  }),
  getAllTisaForexRateCategorySuccess: (data: any) => ({
    type: actionTypes.GET_ALL_TISA_FOREX_RATE_CATEGORY_SUCCESS,
    payload: data,
  }),
  getAllTisaForexRateCategoryFinish: () => ({
    type: actionTypes.GET_ALL_TISA_FOREX_RATE_CATEGORY_FINISH,
  }),

  // ADD
  addTisaForexRateCategory: (data: any) => ({
    type: actionTypes.ADD_TISA_FOREX_RATE_CATEGORY_START,
    payload: data,
  }),
  addTisaForexRateCategorySuccess: (data: any) => ({
    type: actionTypes.ADD_TISA_FOREX_RATE_CATEGORY_SUCCESS,
    payload: data,
  }),
  addTisaForexRateCategoryFinish: () => ({
    type: actionTypes.ADD_TISA_FOREX_RATE_CATEGORY_FINISH,
  }),
  addTisaForexRateCategoryReset: () => ({
    type: actionTypes.ADD_TISA_FOREX_RATE_CATEGORY_RESET,
  }),

  // UPDATE
  updateTisaForexRateCategory: (data: any, id: string) => ({
    type: actionTypes.UPDATE_TISA_FOREX_RATE_CATEGORY_START,
    payload: {data, id},
  }),
  updateTisaForexRateCategorySuccess: (data: any) => ({
    type: actionTypes.UPDATE_TISA_FOREX_RATE_CATEGORY_SUCCESS,
    payload: data,
  }),
  updateTisaForexRateCategoryFinish: () => ({
    type: actionTypes.UPDATE_TISA_FOREX_RATE_CATEGORY_FINISH,
  }),
  updateTisaForexRateCategoryReset: () => ({
    type: actionTypes.UPDATE_TISA_FOREX_RATE_CATEGORY_RESET,
  }),

  // DELETE
  deleteTisaForexRateCategory: (categoryIds: Array<{id: string}>) => ({
    type: actionTypes.DELETE_TISA_FOREX_RATE_CATEGORY_START,
    payload: categoryIds,
  }),
  deleteTisaForexRateCategorySuccess: (data: any) => ({
    type: actionTypes.DELETE_TISA_FOREX_RATE_CATEGORY_SUCCESS,
    payload: data,
  }),
  deleteTisaForexRateCategoryFinish: () => ({
    type: actionTypes.DELETE_TISA_FOREX_RATE_CATEGORY_FINISH,
  }),

  // ACTIVATE
  singleActivateTisaForexRateCategory: (categoryIds: Array<{id: string}>) => ({
    type: actionTypes.SINGLE_ACTIVATE_TISA_FOREX_RATE_CATEGORY_REQUEST,
    payload: categoryIds,
  }),
  singleActivateTisaForexRateCategorySuccess: (data: any) => ({
    type: actionTypes.SINGLE_ACTIVATE_TISA_FOREX_RATE_CATEGORY_SUCCESS,
    payload: data,
  }),
  singleActivateTisaForexRateCategoryFinish: () => ({
    type: actionTypes.SINGLE_ACTIVATE_TISA_FOREX_RATE_CATEGORY_FINISH,
  }),

  // DEACTIVATE
  singleDeactivateTisaForexRateCategory: (categoryIds: Array<{id: string}>) => ({
    type: actionTypes.SINGLE_DEACTIVATE_TISA_FOREX_RATE_CATEGORY_REQUEST,
    payload: categoryIds,
  }),
  singleDeactivateTisaForexRateCategorySuccess: (data: any) => ({
    type: actionTypes.SINGLE_DEACTIVATE_TISA_FOREX_RATE_CATEGORY_SUCCESS,
    payload: data,
  }),
  singleDeactivateTisaForexRateCategoryFinish: () => ({
    type: actionTypes.SINGLE_DEACTIVATE_TISA_FOREX_RATE_CATEGORY_FINISH,
  }),
}
